import SuperJSON from "superjson";
import Id from "../types/Id";

export default class EventId extends Id<"event"> {}

SuperJSON.registerClass(EventId);
